var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('uiBlockTitle',{attrs:{"small":true}},[_vm._v("История")]),_c('PetEventsGroup',{attrs:{"events":_vm.allEvents},on:{"click":_vm.editEvent}}),(_vm.canLoadHistory)?_c('uiButton',{attrs:{"color":"light"},on:{"click":function($event){_vm.loadHistory(_vm.allEvents.at(-1)?.date)}}},[_vm._v(" Загрузить ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }